<template>
  <div class="maker">
    <div class="content">
      <aside class="aside">
        <router-link class="item" v-for="(item,index) in navList" :key="index" :to="item.value">
          {{item.name}}
        </router-link>
        <div class="code-container">
          <span class="code-item app_download">
            <svg-icon name="app_download"></svg-icon>
            <div class="show-code">
              <img class="code-image" src="@/assets/images/app_code.png" alt="">
              <span>扫码下载APP</span>
            </div>
          </span>
          <span class="code-item miniprogram">
            <svg-icon name="miniprogram"></svg-icon>
            <div class="show-code">
              <img class="code-image" src="@/assets/images/miniprogram_code.png" alt="">
              <span>扫码打开小程序</span>
            </div>
          </span>
          <span class="code-item service">
            <svg-icon name="service"></svg-icon>
            <div class="show-code">
              <img class="code-image" src="@/assets/images/service_code.png" alt="">
              <span>联系客服</span>
            </div>
          </span>
        </div>
      </aside>
      <div class="maker-content">
        <div class="inner">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getBanner} from '../api/app'
export default {
  name: 'maker',
  props: {
    msg: String
  },
  data() {
    return {
      navList: [
        {name: '新建配音', value: '/maker/create'}, 
        {name: '精品试听', value: '/maker/template'},
        {name: '我的作品', value: '/maker/audio'},
        {name: '我的草稿', value: '/maker/draft'},
      ],
    }
  },
  mounted() {
    getBanner()
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.maker {
  background-color: #F3F3F3;
}
.content {
  margin: 0 auto;
  position: relative;
  display: flex;
  min-height: 100vh;
}
.aside {
  font-size: 18px;
  color: #FFFFFF;
  width: 140px;
  background: #2D2F34;
  text-align: center;
  padding-top: 130px;
  box-sizing: border-box;
  position: relative;
  a {
    text-decoration: none;
    color: #fff;
    display: block;
  }
  .item {
    height: 42px;
    background: rgb(0 0 0 / 43%);
    line-height: 42px;
    margin-bottom: 20px;
    &.active {
      background-color: #f23d5c;
    }
  }
  .code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 175px;
    width: 100%;
    margin-top: 100px;
    .code-item {
      display: inline-block;
      cursor: pointer;
      position: relative;
      .show-code {
        position: absolute;
        z-index: 111;
        left: 50px;
        top: 50%;
        transform: translate(0, -50%);
        background: #fff;
        color: #555;
        font-size: 14px;
        padding: 10px;
        box-shadow: 0px 2px 8px 0px rgb(85 85 85 / 50%);
        border-radius: 4px;
        display: none;
        .code-image {
          margin-bottom: 5px;
          width: 125px;
        }
      }
      &:hover {
        .show-code {
          display: block;
        }
      }
    }
    .svg-icon {
      &:hover {
        filter: invert(85%) sepia(80%) saturate(20%) hue-rotate(11deg) brightness(1000%) contrast(100%)
      }
    }
    .app_download, .svg-icon--app_download {
      width: 34px;
      height: 37px;
    }
    .miniprogram, .svg-icon--miniprogram {
      width: 34px;
      height: 34px;
    }
    .service, .svg-icon--service {
      width: 36px;
      height: 33px;
    }
  }
}
.maker-content {
  width: 100%;
  padding: 100px 20px 20px 20px;
  box-sizing: border-box;
  .inner {
    background-color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    height: 100%;
  }
}
</style>
